/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-carrier-circles2': {
    width: 535.5,
    height: 535.5,
    viewBox: '0 0 535.5 535.5',
    data: '<path pid="0" d="M374.85 357c-20.399 58.65-76.5 102-145.35 102-84.15 0-153-68.85-153-153 0-66.3 43.35-122.4 102-145.35V153c0-25.5 5.1-51 12.75-73.95C84.15 96.9 0 191.25 0 306c0 127.5 102 229.5 229.5 229.5 114.75 0 209.1-84.15 226.95-191.25C433.5 351.9 408 357 382.5 357h-7.65z"/><path pid="1" d="M382.5 0c-84.15 0-153 68.85-153 153s68.85 153 153 153 153-68.85 153-153S466.65 0 382.5 0zm0 229.5c-43.35 0-76.5-33.15-76.5-76.5s33.15-76.5 76.5-76.5S459 109.65 459 153s-33.15 76.5-76.5 76.5z"/>'
  }
})
